// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gap-2[data-v-58ac81dc]{gap:8px}.gap-3[data-v-58ac81dc]{gap:12px}.gap-4[data-v-58ac81dc]{gap:16px}.bg-white[data-v-58ac81dc]{background-color:#fff!important}.border[data-v-58ac81dc]{border:1px solid #e0e0e0!important}", ""]);
// Exports
module.exports = exports;
